import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as Common from '_common';
import { FloatingWidgetPlaceholder } from './FloatingWidgetPlaceholder';
import { TilesWidgetPlaceholder } from './TilesWidgetPlaceholder';
import { DockedWidgetPlaceholder } from './DockedWidgetPlaceholder';
export function WidgetPlaceholder(props) {
    const [widgets, placementManager] = Common.useWidgets();
    const placeholderWidgets = React.useMemo(() => {
        return placementManager.getWidgets(widgets, props.type, props.name);
    }, [widgets, props.type, props.name]);
    if (props.type === Common.WidgetPlaceholderType.Docked) {
        return (_jsx(DockedWidgetPlaceholder, { widgets: placeholderWidgets, placementManager: placementManager }));
    }
    if (props.type === Common.WidgetPlaceholderType.Tiles) {
        return (_jsx(TilesWidgetPlaceholder, { widgets: placeholderWidgets, placementManager: placementManager }));
    }
    if (props.type === Common.WidgetPlaceholderType.Floating) {
        return (_jsx(FloatingWidgetPlaceholder, { widgets: placeholderWidgets, placementManager: placementManager }));
    }
    throw new Error('Unknown placeholder type: ' + props.type);
}
